import { registerRum } from "@spark/frontend-config";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.tsx";

function createApp(app: React.JSX.Element) {
	const container = document.getElementById("root");
	if (container) {
		const root = createRoot(container);
		root.render(app);
	}
}

registerRum();

createApp(<App />);
